import { Button } from 'antd';
import { Box } from '../../../../box';
import { useTranslation } from '../../../../i18n';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { ModalFooterProps } from './types';

export function ModalFooter(props: ModalFooterProps): ReactElement {
  const [t] = useTranslation();
  return (
    <Box className={styles.modalFooter}>
      <Box>
        <Button autoInsertSpace={false} onClick={props.onCancel}>{t('取消')}</Button>
        <Button className={styles.ml5} type='primary' autoInsertSpace={false} onClick={props.onOk}>{t('确定')}</Button>
      </Box>
    </Box>
  );
}
